// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography, useMediaQuery } from '@mui/material';
import { Box } from '@mui/system';

import DotPagination from '../DotPagination/DotPagination';

import { updateEventInfoAction } from '../../store/actions/createEvent';
import {
  convertFromUTCToGivenTimezone,
  getTimeAndDateString,
} from '../../utils/methods/dateAndTimeMethods';

import Logo from '../../assets/images/Horizontal_logo.svg';
import Favicon from '../../assets/images/SP_2025_LogoSquare_noBGnolines.svg';
import { isUserRole, isActiveRole } from '../../utils/methods/storeFunc';
import { USER_ROLES } from '../../staticData/userRoles';

const PaginationButtonComponent = ({ page, setPage, length, rowsPerPage }) => {
  return (
    <Box
      sx={{
        '& td': {
          display: 'block',
        },
      }}
    >
      <DotPagination
        currPage={page}
        setCurrPage={setPage}
        valueLen={length}
        valueOnPerPage={rowsPerPage}
      />
    </Box>
  );
};

const NoAuthNavBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const auth = useSelector((store) => store.auth);
  const createContactInfo = useSelector((store) => store.createContactInfo);
  const logs = useSelector((store) => store.logs);

  const eventInfo = createContactInfo?.eventInfo;
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const rowsPerPage = 10;

  // State variables start...
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showUserLogs, setShowUserLogs] = useState(false);
  const [page, setPage] = React.useState(0);
  // State variables end...

  // Handlers start...
  const getActivityTimeHandler = ({ activityTime, timezone }) => {
    return getTimeAndDateString(
      convertFromUTCToGivenTimezone({
        dateStr: activityTime,
        timezone,
      }),
    );
  };
  // Handlers end...

  React.useEffect(() => {
    if (auth?.userToken) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, [auth?.userToken]);

  useEffect(() => {
    if (eventInfo && !eventInfo?.userId && auth?.userId && auth?.userToken) {
      if (!isActiveRole(USER_ROLES.CLIENT)) return;
      dispatch(
        updateEventInfoAction({
          payload: {
            userId: auth?.userId,
            ...eventInfo,
          },
          _id: eventInfo?._id,
          successCallback: () => {},
          userAuth: auth,
        }),
      );
    }
  }, [auth?.userId, auth?.userToken, dispatch]);

  // useEffect(() => {
  //   if (showUserLogs) {
  //     // dispatch(getLatestLogsOfUserAction({}));
  //   }
  // }, [showUserLogs, dispatch]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        minWidth: 0,
        padding: isSmallScreen ? '18px 20px' : '25px 40px',
        zIndex: 9,
      }}
    >
      <Box sx={{ minWidth: 0, flexShrink: 1 }}>
        <Link to={location.pathname === '/login' ? '/create-event' : '/'}>
          <img
            style={{
              width: isSmallScreen ? '4.5rem' : '20rem',
            }}
            src={isSmallScreen ? Favicon : Logo}
          />
        </Link>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: isSmallScreen ? '5px' : '15px',
          flexShrink: 0,
          whiteSpace: 'nowrap',
        }}
      >
        {location?.pathname !== '/login' ? (
          <>
            <Typography>
              {isSmallScreen ? '' : 'Continue as '}
              <Typography
                component="span"
                sx={{ color: '#00EEC5', display: 'inline' }}
                // onClick={() => {
                //     // window.location.reload();
                //     navigate("/");
                // }}
              >
                Guest
              </Typography>
            </Typography>
            <Typography>or</Typography>
            <NavLink
              to="/login"
              style={{
                background:
                  'linear-gradient(107.95deg, #FF00FF 0%, #8F00FF 65.99%),linear-gradient(0deg, #FFFFFF, #FFFFFF)',
                borderRadius: '40px',
                padding: isSmallScreen ? '4px 15px' : '8px 35px',
                border: '2px solid white',
                color: '#fff',
                fontWeight: 700,
              }}
              onClick={() => navigate('/login')}
            >
              LOG IN
            </NavLink>
          </>
        ) : null}

        {/* <NavLink
            to="/contractor-signup"
            style={{
                background:
                    "linear-gradient(107.95deg, #FF00FF 0%, #8F00FF 65.99%),linear-gradient(0deg, #FFFFFF, #FFFFFF)",
                borderRadius: "40px",
                padding: "8px 35px",
                border: "2px solid white",
            }}
        >
            CONTRACTOR SIGNUP
        </NavLink> */}
      </Box>
    </Box>
  );
};

PaginationButtonComponent.propTypes = {
  page: PropTypes.number,
  setPage: PropTypes.func,
  length: PropTypes.number,
  rowsPerPage: PropTypes.number,
};

export default NoAuthNavBar;
